import { IChatMessage } from '../interfaces/chat-message.interface';
import { IMessageDayGroup } from '../interfaces/message-day-group.interface';

const startOfDay = (date: Date): number =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

const labelFor = (date: Date): string => {
  const today = startOfDay(new Date());
  const day = startOfDay(date);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (day === today) {
    return 'Hoje';
  }
  if (day === yesterday.getTime()) {
    return 'Ontem';
  }

  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
};

export function groupMessagesByDay(messages: IChatMessage[]): IMessageDayGroup[] {
  const groups: IMessageDayGroup[] = [];
  let currentDay: number | null = null;

  messages.forEach(message => {
    if (!message.timestamp) {
      return;
    }

    const date = new Date(message.timestamp);
    const day = startOfDay(date);

    if (day !== currentDay) {
      groups.push({ label: labelFor(date), messages: [] });
      currentDay = day;
    }

    groups[groups.length - 1].messages.push(message);
  });

  return groups;
}
